import {ActivityPeriodStatus, activityPeriodStatus} from "@ots-frontend/ots-data";

export const getActivityPeriodStatusColorRef = (
  status: ActivityPeriodStatus
): string => {
  switch (status) {
    case activityPeriodStatus.raw:
      return "activity-period-raw";
    case activityPeriodStatus.adminReviewed:
      return "activity-period-admin-reviewed";
    case activityPeriodStatus.vendorEntered:
      return "activity-period-vendor-entered";
    case activityPeriodStatus.adminComplete:
      return "activity-period-admin-complete";
    case activityPeriodStatus.operatorValidated:
      return "activity-period-operator-validated";
    case activityPeriodStatus.vendorApproved:
      return "activity-period-vendor-approved";
    case activityPeriodStatus.operatorCoded:
      return "activity-period-operator-coded";
    default:
      return "activity-period-raw";
  }
};
